import { SITES_GRID_NAME } from '../../constants';

import { actionLoadSitesRequest } from '../../actions/sitesGrid';

import {
  ACTION_SWITCH_SITE_STATUS__REQUEST,
  ACTION_SWITCH_SITE_STATUS__SUCCESS,
  ACTION_SWITCH_SITE_STATUS__FAIL,
  ACTION_DELETE_SITE__REQUEST,
  ACTION_DELETE_SITE__SUCCESS,
  ACTION_DELETE_SITE__FAIL,
} from '../../actionTypes';

import { getGridSaga } from 'react-redux-app/lib/modules/grid/sagas';


export default getGridSaga(
  SITES_GRID_NAME,
  actionLoadSitesRequest,
  [ACTION_SWITCH_SITE_STATUS__REQUEST, ACTION_DELETE_SITE__REQUEST],
  [ACTION_SWITCH_SITE_STATUS__FAIL, ACTION_DELETE_SITE__FAIL],
  [ACTION_SWITCH_SITE_STATUS__SUCCESS, ACTION_DELETE_SITE__SUCCESS]
);
